export type RuntimeConfig = {
  env: string;
  release: string;
  sentryDsn: string;
};

const fallback: RuntimeConfig = { env: "dev", release: "dev", sentryDsn: "" };

// The web image is built once and promoted between environments, so settings come from the server.
export async function loadConfig(): Promise<RuntimeConfig> {
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (!res.ok) return fallback;
    return { ...fallback, ...(await res.json()) };
  } catch {
    return fallback;
  }
}
